import { createSelector } from 'reselect';

export const getProductPrice = (state, sku) => {
    return state.liquors.byId[sku].salePrice;
};
const getCart = (state) => {
    return state.cart;
};
const getProducts = (state) => {
    return state.liquors.byId;
};

export const getTotalPrice = createSelector(
    [getCart, getProducts],
    (cart, products) => {
        if (cart.length) {
            return cart.reduce(
                (acc, item) => acc + item.amount * products[item.sku].salePrice,
                0
            );
        }
    }
);

export const getTotalAmountInCart = createSelector([getCart], (cart) =>
    cart.reduce((acc, item) => acc + item.amount, 0)
);

export const isInCart = (state, sku) =>
    !!state.cart.find((item) => item.sku === sku);
